import React, {ReactNode} from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {ASSET_INFO_TEST_IDS} from './consts';

const LabelValueField = ({
	label: {i18nKey, defaultValue},
	children,
	...rest
}: {
	label: {
		i18nKey: string;
		defaultValue: string;
	};
	children: ReactNode;
}) => {
	// @ts-expect-error I want to filter out className
	const {className, ...otherProps} = rest;
	return (
		<div
			className={`datapoint-info ${className || ''}`}
			data-testid={ASSET_INFO_TEST_IDS.DATAPOINT_INFO}
			{...otherProps}>
			<span data-testid={ASSET_INFO_TEST_IDS.DATAPOINT_LABEL}>
				<Trans i18nKey={i18nKey}>{defaultValue}</Trans>
			</span>

			<label data-testid={ASSET_INFO_TEST_IDS.DATAPOINT_VALUE}>{children}</label>
		</div>
	);
};

export default LabelValueField;
